<template>
  <div id="top">
    <section class="speaker-detail__wrapper color-6">
      <div class="speaker-bio">
        <div class="speaker-img">
          <img
            v-if="avatar === 'https://www.dmgeventsconferences.com/'"
            src="https://www.futureenergyasia.com/media/7674/speaker-default.jpg"
            alt="Default Avatar 300x300"
            class="img-fluid"
          />
          <img
            v-else-if="!avatar"
            src="https://www.futureenergyasia.com/media/7674/speaker-default.jpg"
            alt="Default Avatar 300x300"
            class="img-fluid"
          />
          <img
            v-else
            :src="avatar"
            alt="User Avatar 300x300"
            class="img-fluid"
          />
        </div>
        <div class="speaker-detail__inner">
          <h2 class="color-6-head">{{ name }}</h2>
          <h4>{{ jobTitle }}</h4>
          <h5 class="color-6-head">{{ company }}</h5>
          <img
            v-if="companyLogo != 'https://www.dmgeventsconferences.com/'"
            :src="companyLogo"
            alt="companyLogo"
            width="120"
            height="45"
          />
        </div>
      </div>
      <div class="speaker-content">
        <div class="head-with-inlineborder">
          <h6>
            <img src="/images/person.svg" alt="" width="13" height="13" /> bio
          </h6>
        </div>
        <div class="bio-content">
          <p>{{ biography }}</p>
        </div>
      </div>
      <!-- <div class="content-wrapper" v-if="sessions && sessions.length > 0">
        <h3>Related Sessions</h3>
        <div class="related-content-wrapper">
          <div class="related-contents" v-for="session in sessions" :key="session.id">
            <p class="date">{{session.dateTime}}</p>
            <a
              href="/conferences/gastech-conference-program/"
              target="_self"
            >
              <h4>
                {{session.title}}
              </h4>
            </a>
            <div class="speaker-list" v-if="session.speakers">
              <template v-for="speaker in session.speakers">
                <a :key="speaker.id" v-if="speaker.name !== name"
                :href="`/speakerdetails?userId=${speaker.apiId}`"
                >
                  <h4>{{speaker.name}}</h4>
                </a>
            </template>
            </div>
          </div>
        </div>
      </div> -->
    </section>
  </div>
</template>
<script>
//import $ from 'jquery';
import axios from "axios";
import url from "./../../config/url";
export default {
  name: "ExhibitorProfilePage",
  data: function() {
    return {
      exhibitorid: this.$route.query.userId,
      id: null,
      name: null,
      jobTitle: null,
      company: null,
      biography: null,
      avatar: null,
      country: null,
      companyLogo: null,
      eventname: "",
      sessions:null
    };
  },
  mounted() {
    this.exhibitorDetails(this.exhibitorid);
    const url = window.location.href;
    const domain = url.split("/")[2];
    if (domain === "www.futureenergyasia.com") {
      this.eventname = "fea";
    } else if (domain === "www.future-mobility.asia") {
      this.eventname = "fma";
    } else if (domain === "www.japanenergyevent.com/") {
      this.eventname = "japan";
    } else if (domain === "www.gastechevent.com") {
      this.eventname = "gastech";
    } else {
      this.eventname = "fea";
    }
  },
  methods: {
    exhibitorDetails: function(eId) {
      // debugger
      axios
        .get(url.user_detail_api, { params: { Userid: eId } })
        .then((response) => {
          //    debugger
          this.id = response.data[0].id;
          this.name = response.data[0].name;
          this.jobTitle = response.data[0].jobTitle;
          this.company = response.data[0].company;
          this.biography = response.data[0].biography;
          this.avatar = response.data[0].avatar;
          this.country = response.data[0].country;
          this.companyLogo = response.data[0].companyLogo;
          this.sessions = response.data[0].sessions;
        })
        .catch((error) => {
          console.log(error);
        });
      window.scrollTo(0, 0);
    },

    exhibitorProductData: function() {
      (this.showProductCategory = true),
        (this.showPressRelease = false),
        (this.showBrochure = false);
    },
    exhibitorPressReleaseData: function() {
      (this.showProductCategory = false),
        (this.showPressRelease = true),
        (this.showBrochure = false);
    },
    exhibitorBrochuresData: function() {
      (this.showProductCategory = false),
        (this.showPressRelease = false),
        (this.showBrochure = true);
    },
  },
};
</script>
